<template>
    <div class="layout-popup discuss-float-pop">
        <div class="discuss-float-arrow"></div>
        <div class="discuss-float-pop-bg"></div>
        <div class="discuss-float-pop-content">
            <p v-if="CONFIG.platform == 'wechat'">建议点击『浮窗』开启浮窗，</p>
            <p v-if="CONFIG.platform == 'qq'">建议点击『彩签』开启彩签，</p>
            <p v-if="CONFIG.platform == 'wechat'">不影响微信聊天和论盘，</p>
            <p v-if="CONFIG.platform == 'qq'">不影响QQ聊天和论盘，</p>
            <p>可以随时回来论盘~</p>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config'
export default {
    name: 'DiscussFloatPop',
    data() {
        return {
            CONFIG: CONFIG
        }
    }
}
</script>